import comp from "./Duration";
export default comp;
